import script from "./DateButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./DateButtons.vue?vue&type=script&setup=true&lang=js"

import "./DateButtons.vue?vue&type=style&index=0&id=60fd5174&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fd5174"]])

export default __exports__